// import { colors } from '../colors'

export const offCanvas = {
  backgroundColor: 'red'
}

export default offCanvas
